// Entradas de la navegación principal. `staffOnly` las esconde de los usuarios
// sin is_staff; NavTabs y MobileDrawer filtran con `visibleMenu`.
const Menu = [
    {
        label: "dashboard",
        pathname: "/dashboard"
    },
    {
        label: "results",
        pathname: "/results"
    },
    {
        label: "nine_box",
        pathname: "/ninebox"
    },
    {
        label: "ai_admin",
        pathname: "/ai-admin",
        staffOnly: true
    }

];

// Esconder la pestaña es sólo cosmético: la ruta la protege PrivateRoute con
// staffOnly, y el backend exige IsAdminUser en cada endpoint del panel.
export const visibleMenu = (isStaff) => Menu.filter((item) => !item.staffOnly || isStaff);

export default Menu;
